import { render, staticRenderFns } from "./TranscriptPartWords.vue?vue&type=template&id=05125ebb&scoped=true&"
import script from "./TranscriptPartWords.vue?vue&type=script&lang=ts&"
export * from "./TranscriptPartWords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05125ebb",
  null
  
)

export default component.exports